{
    "RingtimeDistributionLabel": "Beltijd (distributie):",
    "RingtimeSegmentLabel": "Beltijd (segment):",
    "CalltalktimeLabel": "Gesprekstijd bellen:",
    "TotalcalltimeLabel": "Totale gesprekstijd:",
    "CallheldtimeLabel": "Gesprek in de wacht:",
    "TimeComparisonAnyOptionLabel": "[Any]",
    "TimeComparisonHigherthanOptionLabel": "Hoger dan",
    "TimeComparisonHigherequalOptionLabel": "Hoger\/gelijk",
    "TimeComparisonLowerthanOptionLabel": "Lager dan",
    "TimeComparisonLowerequalOptionLabel": "Lager\/gelijk",
    "TimeComparisonBetweenOptionLabel": "Tussen",
    "TimeComparisonEqualOptionLabel": "Gelijkwaardig",
    "TimeComparisonNotequalOptionLabel": "Niet gelijk",
    "TimeComparisonNotbetweenOptionLabel": "Niet tussen",
    "TimeComparisonValue1Label": "Waarde:",
    "TimeComparisonValue2Label": "En:",
    "DurationFiltering_SectionHeader": "Locatiefiltering",
    "NAME": "DurationFiltering"
}